import CommonFunctions from "../utils/helpers/CommonFunctions";

/**
 * Generates rows based on provided counts and attributes options
 * @param {Array} attributesOptions - array of attribute objects { key, value }
 * @param {Object} itemsCount - e.g., { PCA: 3, Guests: 3, Children: 3 }
 * @returns {Array} generated rows
 */
export const generateRows = (attributesOptions = [], itemsCount = {}) => {
  const rows = [];

  const getDefault = (defaultAsAMB = true) => {
    if(defaultAsAMB){
        return (
            attributesOptions.find(opt =>
              ['amb', 'ambu', 'ambulatory'].some(keyword =>
                opt.value?.toLowerCase().startsWith(keyword)
              )
            )?.key || ''
          );
    }
    else{
        return (
            attributesOptions.find(opt =>
              ['wc', 'wheelchair', 'w.c.'].some(keyword =>
                opt.value?.toLowerCase().startsWith(keyword)
              )
            )?.key || ''
        ); 
    }
    
  };

  let _index  = 0;
  Object.entries(itemsCount).forEach(([type, count]) => {
    let _type = type;
    for (let i = 0; i < count; i++) {
      const generatedKey = CommonFunctions.GenerateUUID();
      let attribute = getDefault();


      if(type.toLowerCase() == "pca_wc"){
        _type = 'PCA';
        attribute = getDefault(false);
      }
      else if(type.toLocaleLowerCase() == "guests_wc"){
        _type = 'Guest';
        attribute = getDefault(false);
      }
      else{
        _type = type;
      }

      rows.push({
        key: generatedKey,
        type: "adult",
        selectedLabel: _type,
        index: _index,
        childrenRowIndex: -1,
        selectedAttribute: attribute,
        Name: _type,
        Attributes: attribute
      });
      _index++;
    }
  });

  return rows;
};


export const updateIndexes = (data) => {
  const updated = {};
  let counter = 0;

  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      updated[key] = value.map((item) => ({ ...item, index: counter++ }));
    } else if (typeof value === "object" && value !== null) {
      updated[key] = { ...value, index: counter++ };
    } else {
      updated[key] = value;
    }
  });

  return updated;
};
